import React from 'react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Plus, Trash2, Image } from 'lucide-react';

export const PersoneIdentificateSection = ({ persone, onAdd, onUpdate, onRemove }) => (
  <div className="form-section pl-8">
    <div className="flex items-center justify-between mb-4">
      <h3 className="text-lg font-semibold uppercase text-[#E3000F]" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
        Persone Identificate
      </h3>
      <Button
        onClick={onAdd}
        className="bg-[#1A1A1A] border border-[#333333] hover:border-[#E3000F] text-white rounded-none"
        data-testid="add-persona-btn"
      >
        <Plus className="w-4 h-4 mr-2" />
        Aggiungi
      </Button>
    </div>

    {persone?.map((persona, index) => (
      <div key={index} className="bg-[#0A0A0A] border border-[#27272A] p-4 mb-4 relative">
        {persona.foto_documento_url && (
          <span className="provenance-badge ocr absolute top-2 right-12">
            <Image className="w-3 h-3 mr-1" />
            OCR da foto
          </span>
        )}
        <button
          onClick={() => onRemove(index)}
          className="absolute top-2 right-2 text-[#EF4444] hover:text-white"
          data-testid={`remove-persona-${index}`}
        >
          <Trash2 className="w-4 h-4" />
        </button>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="form-label">Cognome</label>
            <Input value={persona.cognome} onChange={(e) => onUpdate(index, 'cognome', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" data-testid={`persona-cognome-${index}`} />
          </div>
          <div>
            <label className="form-label">Nome</label>
            <Input value={persona.nome} onChange={(e) => onUpdate(index, 'nome', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" data-testid={`persona-nome-${index}`} />
          </div>
          <div>
            <label className="form-label">Data di Nascita</label>
            <Input value={persona.data_nascita} onChange={(e) => onUpdate(index, 'data_nascita', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" placeholder="GG/MM/AAAA" data-testid={`persona-data-nascita-${index}`} />
          </div>
          <div>
            <label className="form-label">Luogo di Nascita</label>
            <Input value={persona.luogo_nascita} onChange={(e) => onUpdate(index, 'luogo_nascita', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" data-testid={`persona-luogo-nascita-${index}`} />
          </div>
          <div className="md:col-span-2">
            <label className="form-label">Residenza</label>
            <Input value={persona.residenza} onChange={(e) => onUpdate(index, 'residenza', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" data-testid={`persona-residenza-${index}`} />
          </div>
          <div>
            <label className="form-label">Documento</label>
            <Input value={persona.documento} onChange={(e) => onUpdate(index, 'documento', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" placeholder="CI XXXXXXXX SCAD. GG/MM/AAAA" data-testid={`persona-documento-${index}`} />
          </div>
          <div className="md:col-span-2">
            <label className="form-label">In qualità di</label>
            <Input value={persona.in_qualita_di} onChange={(e) => onUpdate(index, 'in_qualita_di', e.target.value)} className="bg-[#121212] border-[#27272A] rounded-none text-white" placeholder="es: Proprietario, Residente..." data-testid={`persona-qualita-${index}`} />
          </div>
        </div>
      </div>
    ))}

    {persone?.length === 0 && (
      <p className="text-[#71717A] text-center py-4">Nessuna persona identificata</p>
    )}
  </div>
);
